import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const macCommandSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28" fill="none">
        <path stroke="currentColor"
              d="M11.5 9.5a2 2 0 1 0-2 2h9a2 2 0 1 0-2-2v9a2 2 0 1 0 2-2h-9a2 2 0 1 0 2 2v-9z"></path>
    </svg>
)

const MacCommand: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {macCommandSvg}
    </SvgIcon>
)

export default MacCommand